import { MENU as BILLING_MENU } from "utils/BillingConstants";
import { MENU as SUPPORT_MENU } from "utils/TicketConstants";
import { MENU as PROFILE_MENU } from "utils/ProfileConstants";
import { MENU as STORAGE_MENU } from "utils/StorageConstants";
import { MENU as COLO_MENU } from "utils/ColoConstants";
export const INPUT_TYPES = {
  INPUT: "INPUT",
  TEXTAREA: "TEXTAREA",
};
export const DATACENTER_LOCATIONS = [
  // { location: 'Atlanta', tag: 'ATL', key: 'one' },
  { location: "Chattanooga", tag: "CHA", key: "two", badge: false },
  { location: "Huntsville", tag: "HSV", key: "three", badge: false },
  { location: "Birmingham", tag: "BHM", key: "four", badge: false },
  { location: "Greenville", tag: "GSP", key: "five", badge: false },
  { location: "Myrtle Beach", tag: "MYR", key: "six", badge: false },
];

export const ILA_HUTS = [
  { name: "BLACK", id: "ATL-MYR.P01", state: "GA", city: "Snellville" },
  { name: "HARRISON", id: "ATL-MYR.P02", state: "GA", city: "Bishop" },
  { name: "HULL", id: "ATL-MYR.P03", state: "GA", city: "Crawfordville" },
  { name: "MILLS", id: "ATL-MYR.P04", state: "GA", city: "Grovetown" },
  { name: "BARBER", id: "ATL-MYR.P05", state: "SC", city: "Williston" },
  { name: "COONER", id: "ATL-MYR.P06", state: "SC", city: "Seneca" },
  { name: "SANTEE", id: "ATL-MYR.P07", state: "SC", city: "Moncks Corner" },
  { name: "DONSBACH", id: "ATL-MYR.P08", state: "SC", city: "Georgetown" },
];

export const ADMIN_USER = (env) => {
  switch (env) {
    case "testing":
      return 3;
    case "development":
      return 3;
    case "demo":
      return 3;
    case "staging":
      return 101;
    case "production":
      return 702;
    default:
      return 0;
  }
};

export const PHONEMASK = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const PHONEMASKDOTS = [
  /[1-9]/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const SuccessMessage =
  "Success! Your request has been processed successfully.";
export const ErrorMessage =
  "Looks like something went wrong on our end. Please try again.If the problem persists please call 877-590-1684.";

export const ZipCodeMask = [
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  "-",
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
  /[a-zA-Z1-9]/,
];

export const numberMask = (rawValue) => {
  const numRegex = /([\d]{1,3})/;
  const matches = rawValue.match(numRegex);

  if (!matches) {
    return [];
  }
  const number = matches[1];
  const digits = [];
  const digitCount = number.toString().length;

  for (let i = 0; i < digitCount; i++) {
    digits.push(/[\d]/);
  }
  return digits;
};

export const storageNameMask = (rawValue) => {
  const nameLength = rawValue.length;
  const nameRegex = /[a-zA-Z0-9_-\s]/;
  const chars = [];

  for (let i = 0; i < nameLength; i++) {
    if (nameRegex.test(rawValue[i])) {
      chars.push(nameRegex);
    }
  }

  return chars;
};

export const currencyMask = (rawValue) => {
  const amtRegex = /[$]?([0-9]*)(\.)?([0-9]*)/;
  const matches = rawValue.match(amtRegex);

  if (!matches) {
    return [];
  }

  const digitsBefore = matches[1];
  const digitsAfter = matches[3];
  const regex = ["$"];
  if (digitsBefore.length > 0) {
    digitsBefore
      .match(/\d/g)
      .slice(0, 5)
      .forEach(() => {
        regex.push(/[\d]/);
      });
  }
  regex.push(/\./);
  if (digitsAfter.length > 0) {
    digitsAfter
      .match(/\d/g)
      .splice(0, 2)
      .forEach(() => {
        regex.push(/[\d]/);
      });
  }

  return regex;
};

export const VALIDATIONS = {
  AT_LEAST_ONE_CHAR: {
    message: "At least one character required",
    pattern: /.+/,
  },
  VALID_EMAIL: {
    message: "Please enter a valid email address.",
    pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  },
  VALID_LOCATION: {
    message: "Please choose a location.",
    pattern: /.+/,
  },
  NO_SPECIAL_CHARACTERS: {
    message: "Name must not contain special characters.",
    pattern: /^[a-zA-Z\s]+$/,
  },
};

export const SITE_MODULES = {
  LOGIN: "LOGIN",
  HOME: "- NONE SELECTED -",
  SUPPORT: "SUPPORT",
  STORAGE: "STORAGE",
  BILLING: "BILLING",
  PROFILE: "PROFILE",
  ACCOUNT: "ACCOUNT",
  COLO: "COLO",
};

export const SITE_PAGES = {
  [SITE_MODULES.LOGIN]: "LOGIN",
  HOME: "HOME",
  [SITE_MODULES.SUPPORT]: {
    [SUPPORT_MENU.OVERVIEW]: "SUPPORT OVERVIEW",
    [SUPPORT_MENU.TICKET_HISTORY]: "TICKET HISTORY",
    [SUPPORT_MENU.TICKET_HISTORY_DETAIL]: "TICKET DETAILS",
    [SUPPORT_MENU.REMOTEHANDS]: "REMOTE HANDS",
    [SUPPORT_MENU.GUESTACCESS]: "GUEST ACCESS",
    [SUPPORT_MENU.CREATETICKET]: "CREATE TICKET",
    [SUPPORT_MENU.CREATETICKETBILLING]: "BILLING TICKET",
    [SUPPORT_MENU.CREATETICKETSUPPORT]: "SUPPORT TICKET",
    [SUPPORT_MENU.CREATETICKETOUTAGE]: "OUTAGE TICKET",
  },
  [SITE_MODULES.PROFILE]: {
    [PROFILE_MENU.OVERVIEW]: "ACCOUNT OVERVIEW",
    [PROFILE_MENU.ACCOUNT_MANAGEMENT]: "ACCOUNT MANAGEMENT",
    [PROFILE_MENU.MY_PROFILE]: "MY PROFILE",
    [PROFILE_MENU.COMPANY_PROFILE]: "COMPANY PROFILE",
    [PROFILE_MENU.USER_MANAGEMENT]: "USER MANAGEMENT",
    [PROFILE_MENU.PASSWORD_CHANGE]: "CHANGE PASSWORD",
    [PROFILE_MENU.AVATAR]: "AVATAR",
    [PROFILE_MENU.NOTIFICATIONS]: "ACTIVITIES",
    [PROFILE_MENU.DOCUMENTS]: "DOCUMENTS",
    [PROFILE_MENU.SERVICES]: "SERVICES",
  },
  [SITE_MODULES.STORAGE]: {
    [STORAGE_MENU.OVERVIEW]: "STORAGE OVERVIEW",
    [STORAGE_MENU.MANAGE]: "MANAGE STORAGE",
    [STORAGE_MENU.ADD_STORAGE]: "ADD STORAGE",
    [STORAGE_MENU.DELETE_STORAGE]: "DELETE STORAGE",
    [STORAGE_MENU.DETAIL]: "SHARE DETAIL",
  },
  [SITE_MODULES.BILLING]: {
    [BILLING_MENU.OVERVIEW]: "BILLING OVERVIEW",
    [BILLING_MENU.INVOICES]: "CURRENT INVOICES",
    [BILLING_MENU.HISTORY]: "INVOICE HISTORY",
    [BILLING_MENU.INVOICE_DETAIL]: "INVOICE DETAIL",
    [BILLING_MENU.PAYMENT]: "MAKE A PAYMENT",
  },
  [SITE_MODULES.COLO]: {
    [COLO_MENU.OVERVIEW]: "Colocation OVERVIEW",
    [COLO_MENU.POWER]: "POWER METERING",
    [COLO_MENU.NETWORK]: "NETWORK",
    [COLO_MENU.RACK]: "RACK",
    [COLO_MENU.BADGE]: "BADGE",
  },
};

export const STORAGE_AVATAR_URL_PREFIX =
  "https://www.mydcblox.com/cdn/library/storage";

export const SITE_COLORS = {
  DCBLOX_Red: "#f23722",
  DCBLOX_Purple: "#583a6b",
  DCBLOX_Black: "#000000",
  DCBLOX_Gray: "#5b595b",
  DCBLOX_White: "#efeeed",
  DCBLOX_Aqua: "#79d2de",
  DCBLOX_Lime: "#b5d334",
  DCBLOX_Orange: "#fcaf17",
  Med_Lime: "#a8ad00",
  Dark_Lime: "#949300",
  Med_Rust: "#df6a2e",
  Bright_Rust: "#f58145",
  Dark_Rust: "#af5222",
  Bright_Blue: "#3192f4",
  Blue: "#2a7de1",
  Dark_Blue: "#416ba9",
  Bright_Purple: "#a46cf4",
  Purple: "#9164cc",
  Dark_Purple: "#8060a9",
  Extra_Dark_Purple: "#432c52",
  Bright_Emerald: "#00B0B9",
  Emerald: "#008388",
  Dark_Emerald: "#007377",
  Cool_Gray_Dark_1: "#323e48",
  Cool_Gray_Dark_2: "#5b6670",
  Cool_Gray_Dark_3: "#7b868c",
  Cool_Gray_Med_1: "#a2a9ad",
  Cool_Gray_Med_2: "#c1c5c8",
  Cool_Gray_Med_3: "#cfd2d3",
  Cool_Gray_Light_1: "#d4d7d8",
  Cool_Gray_Light_2: "#dfe1e1",
  Cool_Gray_Light_3: "#edefef",
  Warm_Gray_Dark_1: "#24272a",
  Warm_Gray_Dark_2: "#53575a",
  Warm_Gray_Dark_3: "#6f7271",
  Warm_Gray_Med_1: "#888b8d",
  Warm_Gray_Med_2: "#9ea1a2",
  Warm_Gray_Med_3: "#b0b3b2",
  Warm_Gray_Light_1: "#c8c8c8",
  Warm_Gray_Light_2: "#dedede",
  Warm_Gray_Light_3: "#eeeeee",
  White: "#ffffff",
};
